import React, {useMemo, useState} from 'react'
import TalentAppStep from "../components/TalentAppStep";
import User from "../../../models/User";
import NEWSkillFormButton from '../../profiles/components/NEWSkillFormButton';
import { useAPI } from '../../../config/API';
import FlipMove from "react-flip-move";
import UserDiscipline from "../../../models/UserDiscipline";

export default class AIExperienceStep extends TalentAppStep {
    static path = '/ai-expertise';
    static LastUpdatedMethod = 'lastUpdatedSkills';

    static HasRequirements = false;
    /**
     * The title shown on the form
     */
    static StepTitle = 'AI Expertise';
    /**
     * The subtitle shown on the form
     */
    static StepSubtitle = 'What AI experience do you have, if any? Describing your approach to AI and selecting any related AI skill will help determine how you get matched to client projects.'

    /**
     * The start page info tile
     */
    static StepInfo = 'What AI experience and skills you bring to Wripple projects?'

    /**
     * The Step Section to be grouped in after application approval
     */
    static StepSection = 'Expertise';

    // async componentDidMount() {
    //     super.componentDidMount();
    //     let importedDisciplines = User.getImportedItemsFromResumeForUser(this.props.user.id, 'talent_disciplines');
    //     let currentDisciplines = this.props.user.talent_disciplines || [];
    //     if (currentDisciplines.length > 0 && importedDisciplines?.length > 0 && !this.props.user.isApplicationApproved()) {
    //         let importedIds = TB.map(importedDisciplines, dis => parseInt(dis.id))
    //         let firstIndex = TB.findIndex(currentDisciplines, dis => importedIds?.includes(dis?.id));
    //         if (firstIndex >= 0 && !TB.isNaN(firstIndex)) {
    //             await this.handleChildFormEdit(this.childFormIndexName(firstIndex, 'talent_disciplines'), true)
    //         }
    //     }
    //     const myRequest = await TB.request(TB.api_endpoint('/api/talent-disciplines')).get();
    //     this.setState({ discipline_categories: myRequest.success?.data.discipline_categories });
    // }
    /**
     * Show brief details for user
     */
    static ProfileSectionSummary = (user) => {
        const AIskills = user.skills.filter(skill => skill.category === 1);
        return `${AIskills?.length} AI Skills`;
    };

    /**
     * The step needed before editing
     */
    static StepNeedsValidation(user) {
        if (!user.validateAIExpertise()) {
            return this;
        }

        return false;
    };

    static hasCompleted(user) {
        const { ai_focus_level, ai_work_approach } = user;

        if (!ai_focus_level) return false;
        if (ai_focus_level > 1 && !ai_work_approach?.length) return false;

        return true;
    }

    /**
     * Check if we should prevent application from saving and show alert
     */
    static async getValidProps(user) {
        const { ai_focus_level, ai_work_approach } = user;

        if (!ai_focus_level) {
            TB.alert('danger', 'Select Focus Level', 'You must select an AI focus level.')
            return false;
        }
        if (ai_focus_level > 1 && !ai_work_approach.length) {
            TB.alert('danger', 'Add Approach', 'You must explain your overall approach to using AI in your work.')
            return false;
        };

        return user.validateAIExpertise()
    };

    /**
     * @param {User} user
     * @param {User} auth
     * @returns {Object}
     */
    static reviewMapping(user) {
        let review = {};
        review['AI Focus Level'] = user.ai_focus_level;
        review['AI Approach'] = user.ai_work_approach;
        return review;
    }

    /**
     * The fields mapping for the form
     */
    formFields = () => {
        const { ai_focus_level } = this.props.user;

        const fields = [
            {
                style: styles.fieldSection,
                fields: {
                    heading: (
                        <div style={{ flexBasis: '100%' }}>
                            <h5 className="form-header">
                                AI experience
                            </h5>
                            {/*<p className="form-subheader">*/}
                            {/*    */}
                            {/*</p>*/}
                        </div>
                    )
                }
            },
            {
                style: styles.fieldSection,
                className: 'field-section ai-focus-level',
                fields: {
                    ai_focus_level: {
                        label: 'On a scale of 1-5, how focused are you on integrating AI tools into the deliverables you create for clients?',
                        type: 'select',
                        placeholder: 'Select an option',
                        required: true,
                        options: [
                            { label: 'Select an option', value: '', disabled: true},
                            { value: 1, label: '1 - I do not use AI tools' },
                            { value: 2, label: '2 - Unlikely to use AI tools' },
                            { value: 3, label: '3 - Curious about using AI tools' },
                            { value: 4, label: '4 - Somewhat focused on using AI tools' },
                            { value: 5, label: '5 - Very focused on using AI tools' },
                        ],
                        validationErrors: {
                            isDefaultRequiredValue: 'This field is required.'
                        },
                        style: styles.field,
                        // max: 10,
                        // min: 1,
                        columns: 8
                    },
                }
            },
        ]

        if (ai_focus_level > 1) {
            fields.push({
                style: styles.fieldSection,
                fields: {
                    ai_work_approach: {
                        label: 'What is your overall approach to using AI in your work?',
                        // placeholder: 'placeholder',
                        type: 'textarea',
                        required: ai_focus_level > 1,
                        validationErrors: {
                            isDefaultRequiredValue: 'This field is required.'
                        },
                        style: styles.field,
                        maxLength: 2000,
                        minLength: 50,
                        columns: 8,
                        rows: 12
                    },
                }
            })
        }

        // fields.push({
        //     style: styles.fieldSection,
        //     fields: {
        //         sections: (
        //             <TalentAISkillForm {...this.props} />
        //         )
        //     }
        // })

        return fields;
    };

    renderFormFooter() {
        return (
            <div>

                <div className="talent-role-form mb-4">

                    <div className="wripple-form">
                        <div className="form-container items-stretch">
                    <TalentAISkillForm {...this.props} />

                        </div>
                    </div>
                </div>
            </div>
        )
    }

    /**
     * Are requirements completed?
     *
     * @returns boolean
     */
    // isRequirementComplete() {
    //     const hasDisciplines = TB.filter(this.props.user?.talent_disciplines || [], dis => !!dis?.id)?.length >= 1;
    //     const hasSkills = TB.filter(this.props.user?.skills || [], skill => !!skill?.id)?.length >= 1;
    //     return hasSkills && hasDisciplines;
    // }
    // /**
    //  * Requirement messaging
    //  *
    //  * @returns string
    //  */
    // requirementInfo() {
    //     return 'At least 1 role and skill are required.';
    // }
}
const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        // padding: '0 15px',
        flexBasis: 'unset',
        // flexBasis: '90%'
    },
};


const TalentAISkillForm = (props) => {
    const {
        data: skillData,
        isFetching,
        error
    } = useAPI(['searchTalentSkills', { category: 1 }], {
        // onSuccess: response => {
        //     console.log(response, 'responseresponseresponseresponse')
        //     // props.onSuccess(response);
        // },
        onError: e => {
            console.log(e, 'skillData errror')
        }
    })

    const userSuggested = useMemo(() => {
        let userAISkills = UserDiscipline.skillsForDisciplines(TB.map(props.user.talent_disciplines || [], 'id'));

        if (userAISkills.length > 0) {
            userAISkills = TB.uniqBy(userAISkills, 'id');

            let selectedSkills = TB.filter(props.user.skills || [], skill => skill.category === 1);
            userAISkills = TB.filter(userAISkills, ['category', 1]);

            userAISkills = TB.unionBy(selectedSkills, userAISkills, 'id');
            return TB.take(TB.orderBy(userAISkills,skill => !!skill.self_score, ['desc']), Math.max(selectedSkills?.length, 25))
        }
        return [];
    }, [TB.map(props.user?.skills || [], 'id')]);
    const [model, setModel] = useState({ search: '', suggestedSkills: [] })


    // console.log(props, 'PROPS')
    const handleChange = e => {
        let suggestedSkills = []
        if (e.target.value) {
            // suggestedSkills = props.myList.filter(l => l.name.toLowerCase().includes(e.target.value.toLowerCase()))
            suggestedSkills = skillData.filter(l => l.name.toLowerCase().includes(e.target.value.toLowerCase()))
            if (e.target.value.length === 1) {
                suggestedSkills = suggestedSkills.slice(0, 10);
            }

            if (e.target.value.length === 2) {
                suggestedSkills = suggestedSkills.slice(0, 20);
            }
        }
        setModel({ ...model, search: e.target.value, suggestedSkills })
    }

    const selectSkill = async model => {
        console.log(model, 'MODEL')
        let currentUser = TB.cloneDeep(props.user)
        const user = TB.pick({ ...props.user }, 'skills');
        const skillIndex = TB.findIndex([...props.user.skills], ['id', model.id]);

        console.log({ user, skillIndex })

        if (skillIndex !== -1) {
            console.log('skill exists in user')
            if (!TB.isNil(model.self_score)) {
                console.log('set new skill self_score')
                // user = TB.set(user, `skills[${skillIndex}]`, model);
                user.skills[skillIndex] = model
            } else {
                console.log('not sure what this is doing')
                user.skills = TB.filter(user.skills, skill => skill.id !== model.id)
            }
        } else {
            console.log('user doesnt have skill, add the whole skill to user')
            user.skills.push({ ...model })
        }

        user.skills = TB.filter(user.skills, s => !TB.isNil(s?.id))
        await props.onChange(TB.cloneDeep(user));
        // let didSubmit = await props.onSubmit(props.user, false, true);
        //
        // if (!didSubmit) {
        //     TB.showServerErrorToast();
        //     await props.onChange(currentUser);
        // } else {
        //     TB.toast('Profile Updated')
        // }

    };

    const userSkills = TB.keyBy(props.user.skills, 'id');


    return (
        <div>

            <div className="mb-5">
                <div className="field-section">
                    <h5 className="form-header">
                        My AI skills
                    </h5>
                    <p className="form-subheader">Add AI skills recommended from your selected roles and select level of expertise:</p>
                </div>



                <div className="mb-3">
                    {!userSuggested?.length && (
                        <div className="pt-5">
                            <p className="italic text-center">No recommended AI skills. Try searching below</p>
                        </div>
                    )}
                    <div className="flex gap-3 flex-wrap pt-5">
                        <FlipMove typeName={null} maintainContainerHeight={true}>
                            {TB.map(userSuggested,skill => {
                                // return skill.name

                                if (TB.isDefined(props.user.skills[skill.id])) return null
                                return (
                                    <div key={`skill-${skill.id}`}>
                                        <NEWSkillFormButton
                                            className="min-w-[165px]" // match width of widest dropdown menu option to avoid jumping widths
                                            // disabled
                                            skill={skill}
                                            // scoringOptions={SCORING_OPTIONS}
                                            scoringOptions={laravel.talent_scoring_options_by_category[skill.category]}
                                            onChange={selectSkill}
                                            type="info"
                                        />
                                    </div>
                                )
                            })}
                        </FlipMove>
                    </div>
                </div>
            </div>

            <div>
                <label htmlFor="search-ai" className="text-[#343741] text-xs font-bold">Search for additional AI skills</label>
                <input
                    id="search-ai"
                    type="text"
                    disabled={!skillData?.length}
                    className="border h-[43px] bg-[#F5F6F8] px-4 py-1 w-full text-xs"
                    value={model.search}
                    onChange={handleChange}
                    placeholder="Search AI skills"
                />
            </div>


            {!!model.search.length && !model.suggestedSkills.length && (
                <div className="pt-5">
                    <p className="text-center">No skills found</p>
                </div>
            )}

            <div className="flex gap-3 flex-wrap pt-5">
                <FlipMove typeName={null} maintainContainerHeight={true}>
                    {model.suggestedSkills.map(suggestedSkill => {
                        if (TB.isDefined(userSkills[suggestedSkill.id])) return null
                        return (
                            <div key={`suggestedSkill-${suggestedSkill.id}`}>
                                <NEWSkillFormButton
                                    key={suggestedSkill.id}
                                    className="min-w-[150px]"
                                    skill={suggestedSkill}
                                    scoringOptions={laravel.talent_scoring_options_by_category[suggestedSkill.category]}
                                    onChange={selectSkill}
                                    type="info"
                                />
                            </div>
                        )
                    })}

                </FlipMove>
            </div>
        </div>
    )
}